import { createScopedTranslationKeys } from '@dreryk/react-common';

export const translations = {
   pl: {
      '~libs.desktop.shared.appointment-advance-payment': {
         advancePaymentAmount: 'Kwota przedpłaty',
         advancePaymentDate: 'Data przedpłaty',
         advancePaymentMethodType: 'Forma przedpłaty',
         advancePaymentNotProcessed: 'Przedpłata nie została jeszcze opłacona lub zaksięgowana.',
         advancePaymentNotProcessedNoAutomaticRefund:
            'Przedpłata nie została jeszcze opłacona lub zaksięgowana. Odwołanie wizyty nie będzie skutkować automatycznym zleceniem zwrotu przedpłaty.',
         advancePaymentOverpayment: 'Nadpłata ({{amount}})',
         advancePaymentOverpaymentText: '(nadpłata {{amount}})',
         advancePaymentPaid: 'Opłacona',
         advancePaymentPaidAmount: 'Przedpłata opłacona',
         advancePaymentPendingOnlinePaymentsTotalAmount: 'Oczekuje na wpłatę',
         advancePaymentRefundAmount: 'Wysokość zwrotu',
         advancePaymentRefundMethodType: 'Forma zwrotu przedpłaty',
         advancePaymentRefundToBeCreatedAmount: 'Kwota zwrotu',
         advancePaymentRefundToBeCreatedMethodType: 'Forma zwrotu nadpłaty',
         advancePaymentRefundsTotalAmount: 'Suma zwrotów',
         advancePaymentRemainingAmount: 'Brakująca kwota',
         advancePaymentRequiredAmount: 'Przedpłata wymagana',
         advancePaymentSettlement: 'Rozliczenie przedpłaty',
         advancePaymentSummary: 'Podsumowanie przedpłaty',
         advancePaymentSurchargeMethodType: 'Forma dopłaty',
         advancePaymentUnderpayment: 'Niedopłata ({{amount}})',
         advancePaymentUnderpaymentText: '(niedopłata {{amount}})',
         automaticAdvancePaymentRefundsDetails:
            'Zwrot przedpłaty zlecony zostanie automatycznie po odwołaniu wizyty. Maksymalny czas realizacji zwrotu to 14 dni roboczych.',
         automaticAdvancePaymentRefundsExpiredDetails:
            'Upłynął regulaminowy czas na odwołanie wizyty z automatycznym zwrotem przedpłaty. W razie potrzeby możesz wykonać zwrot samodzielnie.',
         automaticRefundsPossibleTo: '(przy odwołaniu do {{date}})',
         close: 'Zamknij',
         copyLink: 'Kopiuj link',
         generateAndSendLinkToPayment: 'Generuj i wyślij link do płatności',
         generateLinkToPayment: 'Generuj link do płatności',
         linkToPayment: 'Link do płatności',
         linkToPaymentGeneratedSuccessfully: 'Pomyślnie wygenerowaliśmy link do płatności.',
         linkToPaymentHasBeenCopied: 'Link do płatności został skopiowany do schowka',
         onlinePaymentLinkWillSendToPhoneNumber:
            'Link do płatności online zostanie przesłany na wskazany numer telefonu.',
         overpaymentRefundRequested: 'Zlecenie zwrotu nadpłaty zostało przekazane do realizacji.',
         overpaymentRefundedAutomatically:
            'Zwrot nadpłaty zlecony zostanie automatycznie. Maksymalny czas realizacji zwrotu to 14 dni roboczych.',
         paymentMethodTypeMap: {
            BANK_TRANSFER: 'Przelew',
            CASH: 'Gotówka',
            ONLINE_PAYMENT: 'Płatność online',
            OTHER: 'Inna',
            PAYMENT_CARD: 'Karta płatnicza',
         },
         phoneNumberForLinkSending: 'Numer telefonu do wysyłki linku',
         refundMethodTypeMap: {
            ONLINE_PAYMENT: 'PayU',
         },
         remainingAmountForThatLink: 'Kwota do opłacenia przez ten link',
         returnOverpayment: 'Zwróć nadpłatę',
         sendLinkUsingSMS: 'Wyślij link SMSem',
         shareLinkToPayment: 'Udostępnij link do płatności',
         shareLinkToUnderpayment: 'Udostępnij link do dopłaty',
         smsLinkSendRequested: 'Zlecono wysyłkę SMS z linkiem.',
         smsSendRequested: 'Zleciliśmy wysyłkę SMS.',
         smsWithLinkSendingFailed:
            'Nie udało się wysłać wiadomości SMS z linkiem do płatności na wskazany numer telefonu.',
         unsupportedPhoneNumberForSendingLink:
            'Nieobsługiwany numer telefonu. Wygenerowany link do płatności będzie można skopiować i wysłać w inny sposób.',
         visitCancelledTooLate: '(zbyt późne odwołanie wizyty)',
      },
   },
};

export const translationKeys = createScopedTranslationKeys(
   translations.pl,
   '~libs.desktop.shared.appointment-advance-payment'
);
